'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest(origin, algo, encoding, encapsulate, files) {
  this.wN = null;
  this.Cg = null;
  this.Ci = null;
  this.Ch = false;
  this.Cj = null;
  this.wN = origin;
  this.Cg = algo;
  this.Ci = encoding;
  this.Ch = encapsulate;
  this.Cj = files;
}
export { $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
$p = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
$h_Lpresto_AgentView$LocalPjeOfficeSignFileRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("LocalPjeOfficeSignFileRequest"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wN));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cg));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ci));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Ch ? 1231 : 1237));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Cj));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 5);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest)) {
    if (((((this.Ch === x$0.Ch) && (this.wN === x$0.wN)) && (this.Cg === x$0.Cg)) && (this.Ci === x$0.Ci))) {
      var x = this.Cj;
      var x$2 = x$0.Cj;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "LocalPjeOfficeSignFileRequest";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.wN;
      break;
    }
    case 1: {
      return this.Cg;
      break;
    }
    case 2: {
      return this.Ci;
      break;
    }
    case 3: {
      return this.Ch;
      break;
    }
    case 4: {
      return this.Cj;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.pv = (function() {
  return this.wN;
});
function $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hE)));
}
export { $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $isArrayOf_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
var $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeSignFileRequest, "presto.AgentView$LocalPjeOfficeSignFileRequest", ({
  hE: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest as $d_Lpresto_AgentView$LocalPjeOfficeSignFileRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Sign-File-Request.js.map
